import cn from 'classnames';
import React, { useRef } from 'react';

import {
  ESearchDropdownAlignment,
  useSearchDropdownAlignment,
} from '@/hooks/useSearchDropdownAlignment';

type TDesktopFilterContentProps = {
  isOpened: boolean;
  content: React.ReactNode;
  footerContent?: React.ReactNode;
  className?: string;
  buttonRef?: React.RefObject<HTMLDivElement>;
  searchBarRef?: React.RefObject<HTMLDivElement>;
  align: ESearchDropdownAlignment;
  useSearchBarWidth?: boolean;
};

const PADDING_OFFSET = 52;

export const DesktopFilterContent = ({
  isOpened,
  content,
  footerContent,
  className,
  buttonRef,
  searchBarRef,
  align,
  useSearchBarWidth = false,
}: TDesktopFilterContentProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { left, rightAlignConst, useAlign, searchBarWidth, isPositioned } =
    useSearchDropdownAlignment(
      align,
      isOpened,
      PADDING_OFFSET,
      buttonRef,
      searchBarRef,
      dropdownRef,
    );

  if (!isOpened) return null;

  return (
    <div
      ref={dropdownRef}
      className={cn(
        'absolute w-fit z-50 p-6 bg-white top-full translate-y-2 rounded-lg shadow-500 transition-opacity duration-200',
        className,
      )}
      style={{
        left: useAlign === 'right' ? rightAlignConst : left,
        width: useSearchBarWidth && searchBarWidth ? `${searchBarWidth}px` : undefined,
        opacity: isPositioned ? 1 : 0,
      }}>
      {content}
      {footerContent}
    </div>
  );
};
